(() => {
  const sectionSelector = '[data-collab-carousel]';

  const initializeCarousel = (section) => {
    if (!section || section.dataset.collabCarouselInitialized === 'true') return;

    const viewport = section.querySelector('[data-collab-carousel-viewport]');
    const track = section.querySelector('[data-collab-carousel-track]');
    const slides = Array.from(section.querySelectorAll('[data-collab-slide]'));
    const controls = section.querySelector('[data-collab-carousel-controls]');
    const previousButton = section.querySelector('[data-collab-carousel-previous]');
    const nextButton = section.querySelector('[data-collab-carousel-next]');
    const counter = section.querySelector('[data-collab-carousel-counter]');

    if (!viewport || !track || slides.length === 0 || !controls || !previousButton || !nextButton) return;

    section.dataset.collabCarouselInitialized = 'true';
    let scrollFrame;

    const getStep = () => {
      if (slides.length > 1) {
        return slides[1].offsetLeft - slides[0].offsetLeft;
      }
      return slides[0].getBoundingClientRect().width;
    };

    const getVisibleCount = () => {
      const step = getStep();
      if (!step) return 1;
      return Math.max(1, Math.round(viewport.clientWidth / step));
    };

    const updateControls = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const hasOverflow = maxScroll > 2;
      controls.hidden = !hasOverflow;

      if (!hasOverflow) {
        previousButton.disabled = true;
        nextButton.disabled = true;
        if (counter) counter.textContent = '';
        return;
      }

      previousButton.disabled = viewport.scrollLeft <= 2;
      nextButton.disabled = viewport.scrollLeft >= maxScroll - 2;

      if (counter) {
        const step = getStep();
        const visibleCount = getVisibleCount();
        const firstVisible = step ? Math.min(slides.length - 1, Math.max(0, Math.round(viewport.scrollLeft / step))) : 0;
        const lastVisible = Math.min(slides.length, firstVisible + visibleCount);
        counter.textContent = visibleCount > 1
          ? `${firstVisible + 1}–${lastVisible} of ${slides.length}`
          : `${firstVisible + 1} of ${slides.length}`;
      }
    };

    const scrollByOneCard = (direction) => {
      viewport.scrollBy({
        left: getStep() * direction,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    previousButton.addEventListener('click', () => scrollByOneCard(-1));
    nextButton.addEventListener('click', () => scrollByOneCard(1));

    viewport.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateControls);
    }, { passive: true });

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollByOneCard(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollByOneCard(1);
      }
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(viewport);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', updateControls);
    }

    updateControls();
  };

  const initializeWithin = (container = document) => {
    if (container.matches?.(sectionSelector)) initializeCarousel(container);
    container.querySelectorAll?.(sectionSelector).forEach(initializeCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin());
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-collab-slide]');
    if (!slide) return;
    slide.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  });
})();
